import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import React from "react";
import Colors from "../../assets/colors/Colors";

const SkeletonLine: React.FC<{count: number, width: number}> = ({count, width}) => {
    return (
        <SkeletonTheme color={Colors.loader} highlightColor={Colors.loaderHighlight}>
            <div style={{ maxWidth: width }}>
                <Skeleton count={count} width={width}/>
            </div>
        </SkeletonTheme>
    )
};

const SkeletonLineF: React.FC = () => {
    return (
        <SkeletonTheme color={Colors.loader} highlightColor={Colors.loaderHighlight}>
            <div>
                <Skeleton/>
            </div>
        </SkeletonTheme>
    )
};

const StyledSkeletonLine: React.FC<{customStyle?: object, count?: number}> = ({customStyle = {}, count = 1}) => {
    return (
        <div style={{...customStyle}}>
            <SkeletonTheme color={Colors.loader} highlightColor={Colors.loaderHighlight}>
                <div>
                    <Skeleton count={count}/>
                </div>
            </SkeletonTheme>
        </div>
    )
};


const SkeletonWorldCircle: React.FC<{customStyle?: object, height?: number, width?: number}> = ({customStyle = {}, height = 100, width= 100 }) => {
    return (
        <div style={{...customStyle}}>
            <SkeletonTheme color={Colors.loader} highlightColor={Colors.loaderHighlight}>
                <span style={{margin: 10}}>
                    <Skeleton circle={true} height={height} width={width}/>
                </span>
                <span style={{margin: 10}}>
                    <Skeleton circle={true} height={height} width={width}/>
                </span>
                <span style={{margin: 10}}>
                    <Skeleton circle={true} height={height} width={width}/>
                </span>
            </SkeletonTheme>
        </div>
    )
};

const StyledSkeletonCircle: React.FC<{customStyle?: object, height?: number, width?: number}> = ({customStyle = {}, height = 100, width= 100 }) => {
    return (
        <div id='StyledSkeletonCircle' style={{...customStyle}}>
            <SkeletonTheme color={Colors.loader} highlightColor={Colors.loaderHighlight}>
                <Skeleton circle={true} height={height} width={width}/>
            </SkeletonTheme>
        </div>
    )
};

export {
    SkeletonLine,
    SkeletonWorldCircle,
    StyledSkeletonCircle,
    SkeletonLineF,
    StyledSkeletonLine
}